import { render } from "./nps-nav-icon.vue.js?vue&type=template&id=5045190d!=!../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./nps-nav-icon.vue?vue&type=template&id=5045190d"
const script = {}

import exportComponent from "../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__